import { render, staticRenderFns } from "./Banco.vue?vue&type=template&id=275e76b8"
import script from "./Banco.vue?vue&type=script&lang=js"
export * from "./Banco.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports